import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SqlServerForm from '../forms/sql-server-form';
import { sqlServerValidationSchema } from '../schema/sqlServer';

export default function SqlServerNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'SQL Server Node Details',
        altText: 'SQL Server Node',
        defaultLabel: 'SQL Server Node',
      }}
    >
      <CommonNode FormComponent={SqlServerForm} schemaResolver={sqlServerValidationSchema} />
    </NodeProvider>
  );
}
